// import * as React from 'react'
import Loadable from 'react-loadable'
import LoadingComponent from 'components/common/loading-component'
const ColorPicker: any = Loadable({
  // @ts-ignore
  loader: () => import('./twitter-picker'),
  loading: LoadingComponent,
})
export default ColorPicker
